import React from "react";
import {
  Box,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Text,
  RangeSlider,
  RangeSliderTrack,
  RangeSliderFilledTrack,
  RangeSliderThumb,
} from "@chakra-ui/react";
import {
  primaryAlt,
  textPrimary,
  white,
  textSecondary,
  backgroundGrey,
} from "../../utils/colors";

const FormControlRangePicker = ({
  isRequired,
  label,
  isError,
  isTouched,
  w,
  errorMessage,
  isSmall,
  min,
  max,
  setMin,
  setMax,
  minFilter,
  maxFilter,
  step,
  mb,
}) => {
  const handleChange = (values) => {
    setMin(values);
    setMax(values);
  };

  // USE EFFECT

  // LOGS
  // console.log("min", min);
  // console.log("max", max);

  return (
    <FormControl
      mb={mb ? mb : 8}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel
        fontSize={isSmall ? "xs" : "sm"}
        position="relative"
        color={textPrimary}
      >
        {label}

        {isError && isTouched && (
          <Box position="absolute" top={-1} right={0} zIndex={2}>
            <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
          </Box>
        )}
      </FormLabel>
      <Box w="100%" p="0 1rem">
        <RangeSlider
          defaultValue={[min || minFilter, max || maxFilter]}
          min={minFilter}
          max={maxFilter}
          step={step}
          onChange={handleChange}
          zIndex="0"
        >
          <RangeSliderTrack bg={backgroundGrey}>
            <RangeSliderFilledTrack bg={primaryAlt} />
          </RangeSliderTrack>
          <RangeSliderThumb
            boxSize={4}
            index={0}
            bg={primaryAlt}
            border={`2px solid ${white}`}
          >
            {/* <Icon color={textSecondary} as={TbDots} fontSize="0.75rem" /> */}
            <Text
              fontSize="13px"
              color={textSecondary}
              fontWeight="500"
              position="absolute"
              top="100%"
              mt={2}
            >
              {min === "" ? "0" : min}
            </Text>
          </RangeSliderThumb>
          <RangeSliderThumb
            boxSize={4}
            index={1}
            bg={primaryAlt}
            border={`2px solid ${white}`}
          >
            {/* <Icon color={textSecondary} as={TbDots} /> */}
            <Text
              fontSize={max === 150 ? "14px" : "13px"}
              color={textSecondary}
              fontWeight="500"
              position="absolute"
              top="100%"
              mt={2}
            >
              {max === 150 ? "∞" : max === "" ? "∞" : max}
            </Text>
          </RangeSliderThumb>
        </RangeSlider>
      </Box>
    </FormControl>
  );
};

export default FormControlRangePicker;
